import { render } from "./ChartContainerCoinFutures.vue?vue&type=template&id=6f6be22b"
import script from "./ChartContainerCoinFutures.vue?vue&type=script&lang=js"
export * from "./ChartContainerCoinFutures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__